import publicRoutes from "../../apiRoutes/publicRoutes";
import { api } from "../ConsumeApiController";

export async function getHomeData()
{
    const response = await api.get(publicRoutes.home.index);
    if(response.success)
    {
        const {active_city_id, featured_merchants, upcoming_events} = response.data;
        //return {active_city_id, featured_merchants, upcoming_events};
        return response.data;
    }
    return response;
}